<ng-template #offcanvasTemplate let-offcanvas>
  <div class="offcanvas-header">
    <h4 class="offcanvas-title">
      {{ options.title }}
    </h4>
    <button type="button" class="btn-close" (click)="close()"></button>
  </div>
  <div class="offcanvas-body">
    <ng-content></ng-content>
  </div>
</ng-template>
